import { JobFailureMessage } from '@/store/modules/admin/types/admin.types';

export function isJobFailure(data: any): data is JobFailureMessage {
  return data && 'jobId' in data && 'status' in data && 'message' in data;
}
